import React from 'react';

import { Stack } from '@mui/material';

import ContactBar from './ContactBar';
import Messages from './Messages';
import Compose from './Compose';

const ChatPrimary = () => {
  return (
    <Stack direction="column">
      <ContactBar />
      <Messages />
      <Compose />
    </Stack>
  );
};

export default ChatPrimary;
